// frontend/src/components/Pages/DashboardGeodesy.js
import React, { useState, useEffect, useCallback, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Modal, Button, Form, InputGroup, Row, Col } from "react-bootstrap";
import axios from "axios";
import authService from '../../services/authService';
import { useNavigate, Link } from 'react-router-dom';
import './DashboardGeodesy.css'; // Ensure this CSS file exists

const SearchIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
  </svg>
);

const geodesyRoleEditableFieldsOnFrontend = [
  'status',
  'geodesy_receive_date',
  'geodesy_operator_name',
  'geodesy_send_date',
];

const geodesyCheckingMainLabel = "Geodesy Checking";

const statusOptionsForGeodesy = [
  "1st_proof", "2nd_proof", "3rd_proof", "Geodesy", "Boundary_section",
  "GIS", "Digital_Carto", "Director_office", "DPCO", "CTP", "LPO"
];
// Options for admin edits, consistent with Dashboard2Party
const partyUnitOptions = [
  "1Party", "2Party", "3Party", "4Party", "5Party",
  "1Carto", "2Carto", "Photo_office"
];
const seasonOptions = [
  "2022-2023", "2023-2024", "2024-2025", "2025-2026",
  "2026-2027", "2027-2028", "2028-2029", "2029-2030",
  "2030-2031", "2031-2032"
];
const workingStatusOptions = [
  "In progress", "Pending", "Submitted", "Completed"
];


function DashboardGeodesy() {
  const [showEditModal, setShowEditModal] = useState(false);
  const [editFormData, setEditFormData] = useState({});
  const [editingRowId, setEditingRowId] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedPartyUnitFilter, setSelectedPartyUnitFilter] = useState('');
  const [selectedSeasonFilter, setSelectedSeasonFilter] = useState('');

  const navigate = useNavigate();
  
  const columnStructure = useMemo(() => [
    { label: "SL", category: "General", fields: [{ name: "sl", label: "SL" }] },
    { label: "Upazila sheet/Sheet number", category: "General", fields: [{ name: "upazila_sheet", label: "Upazila sheet/Sheet number" }] },
    { label: "Party/Unit", category: "General", fields: [{ name: "party_unit", label: "Party/Unit" }] },
    { label: "Surveyor name", category: "General", fields: [{ name: "surveyor_name", label: "Surveyor name" }] },
    { label: "Status", category: "General", fields: [{ name: "status", label: "Status" }] },
    { label: "Season", category: "General", fields: [{ name: "season", label: "Season" }] },
    { label: "Working_Status", category: "General", fields: [{ name: "working_status", label: "Working Status" }] },
    { label: "GIS Preparation for 1st Proof", category: "Proof Stages", fields: [{ name: `gis1_receive_date`, label: `Receive Date` }, { name: `gis1_operator_name`, label: `Operator name` }, { name: `gis1_send_date`, label: `Send Date` }] },
    { label: "Cartrographic Preparation for 1st Proof", category: "Proof Stages", fields: [{ name: `carto1_receive_date`, label: `Receive Date` }, { name: `carto1_operator_name`, label: `Operator name` }, { name: `carto1_send_date`, label: `Send Date` }] },
    { label: "1st_proof correction by party", category: "Proof Stages", fields: [{ name: `corr1_receive_date`, label: `Receive Date` }, { name: `corr1_operator_name`, label: `Operator name` }, { name: `corr1_send_date`, label: `Send Date` }] },
    { label: "GIS Preparation for 2nd Proof", category: "Proof Stages", fields: [{ name: `gis2_receive_date`, label: `Receive Date` }, { name: `gis2_operator_name`, label: `Operator name` }, { name: `gis2_send_date`, label: `Send Date` }] },
    { label: "Cartrographic Preparation for 2nd Proof", category: "Proof Stages", fields: [{ name: `carto2_receive_date`, label: `Receive Date` }, { name: `carto2_operator_name`, label: `Operator name` }, { name: `carto2_send_date`, label: `Send Date` }] },
    { label: "2nd_proof correction by party", category: "Proof Stages", fields: [{ name: `corr2_receive_date`, label: `Receive Date` }, { name: `corr2_operator_name`, label: `Operator name` }, { name: `corr2_send_date`, label: `Send Date` }] },
    { label: "GIS Preparation for 3rd Proof", category: "Proof Stages", fields: [{ name: `gis3_receive_date`, label: `Receive Date` }, { name: `gis3_operator_name`, label: `Operator name` }, { name: `gis3_send_date`, label: `Send Date` }] },
    { label: "Cartrographic Preparation for 3rd Proof", category: "Proof Stages", fields: [{ name: `carto3_receive_date`, label: `Receive Date` }, { name: `carto3_operator_name`, label: `Operator name` }, { name: `carto3_send_date`, label: `Send Date` }] },
    { label: "3rd_proof correction by party", category: "Proof Stages", fields: [{ name: `corr3_receive_date`, label: `Receive Date` }, { name: `corr3_operator_name`, label: `Operator name` }, { name: `corr3_send_date`, label: `Send Date` }] },
    { label: "Boundary Checking", category: "Boundary/Geodesy", fields: [{ name: "boundary_receive_date", label: "Receive Date" }, { name: "boundary_operator_name", label: "Operator name" }, { name: "boundary_send_date", label: "Send Date" }] },
    { label: "Geodesy Checking", category: "Boundary/Geodesy", fields: [{ name: "geodesy_receive_date", label: "Receive Date" }, { name: "geodesy_operator_name", label: "Operator name" }, { name: "geodesy_send_date", label: "Send Date" }] },
    { label: "sheet coreection by D.Dev", category: "DDEV/DPCO/CTP/LPO", fields: [{ name: "ddev_receive_date", label: "Receive Date" }, { name: "ddev_corrected_by", label: "Corrected by" }, { name: "ddev_send_date", label: "Send Date" }, { name: "ddev_send_to", label: "Send to" }] },
    { label: "GIs preparation from D.Dev", category: "DDEV/DPCO/CTP/LPO", fields: [{ name: "ddev_gis_receive_date", label: "Receive Date" }, { name: "ddev_gis_operator_name", label: "Operator name" }, { name: "ddev_gis_send_date", label: "Send Date" }] },
    { label: "cartrophic preparation from D.Dev", category: "DDEV/DPCO/CTP/LPO", fields: [{ name: "ddev_carto_receive_date", label: "Receive Date" }, { name: "ddev_carto_operator_name", label: "Operator name" }, { name: "ddev_carto_send_date", label: "Send Dates" }] },
    { label: "Director preparation from D.Dev", category: "DDEV/DPCO/CTP/LPO", fields: [{ name: "ddev_director_receive_date", label: "Receive Date" }, { name: "ddev_director_corrected_by", label: "corrected By" }, { name: "ddev_director_send_date", label: "Send Date to DPCO" }] },
    { label: "sheet coreection by DPCO", category: "DDEV/DPCO/CTP/LPO", fields: [{ name: "dpco_receive_date", label: "Receive Date" }, { name: "dpco_corrected_by", label: "Corrected by" }, { name: "dpco_send_date", label: "Send Date" }, { name: "dpco_send_to", label: "Send to" }] },
    { label: "GIs preparation from DPCO", category: "DDEV/DPCO/CTP/LPO", fields: [{ name: "dpco_gis_receive_date", label: "Receive Date" }, { name: "dpco_gis_operator_name", label: "Operator name" }, { name: "dpco_gis_send_date", label: "Send Date" }] },
    { label: "cartrophic preparation from DPCO", category: "DDEV/DPCO/CTP/LPO", fields: [{ name: "dpco_carto_receive_date", label: "Receive Date" }, { name: "dpco_carto_operator_name", label: "Operator name" }, { name: "dpco_carto_send_date", label: "Send Dates" }] },
    { label: "Preparation from DPCO", category: "DDEV/DPCO/CTP/LPO", fields: [{ name: "dpco_prep_receive_date", label: "Receive Date" }, { name: "dpco_prep_operator_name", label: "Operator name" }, { name: "dpco_prep_send_date", label: "Send Date to Cartrographic" }] },
    { label: "DPCO to GIS", category: "DDEV/DPCO/CTP/LPO", fields: [{ name: "dpco_to_gis_receive_date", label: "Receive Date" }, { name: "dpco_to_gis_operator_name", label: "Operator name" }, { name: "dpco_to_gis_send_date", label: "Send Dates" }] },
    { label: "DPCO to Carto", category: "DDEV/DPCO/CTP/LPO", fields: [{ name: "dpco_to_carto_receive_date", label: "Receive Date" }, { name: "dpco_to_carto_operator_name", label: "Operator name" }, { name: "dpco_to_carto_send_date", label: "Send Dates" }] },
    { label: "DPCO to CTP", category: "DDEV/DPCO/CTP/LPO", fields: [{ name: "dpco_to_CTP_receive_date", label: "Receive Date" }, { name: "dpco_to_CTP_corrected_by", label: "corrected By" }, { name: "dpco_to_CTP_send_date", label: "Send Date to LPO" }] },
    { label: "Print by LPO(Date)", category: "DDEV/DPCO/CTP/LPO", fields: [{ name: "lpo_print_date", label: "Print by LPO (Date)" }] }
  ], []);

  const allFields = useMemo(() => columnStructure.flatMap(group => group.fields), [columnStructure]);
  // No fieldsForAddModal needed as Add button is removed for Geodesy

  //const API_BASE_URL = "http://localhost:5000/api/2party"; // Still uses the same API endpoint
  const API_BASE_URL = "https://sheettrackernode.sobalex.com/api/geodesy";

  const getCategoryClass = (category) => { /* ... same as before ... */ 
    switch (category) {
      case "General": return "general-column-group";
      case "Proof Stages": return "proof-stages-column-group";
      case "Boundary/Geodesy": return "geo-column-group";
      case "DDEV/DPCO/CTP/LPO": return "ddev-dpco-column-group";
      default: return "";
    }
  };

  const fetchData = useCallback(async (editedRowIdToCheck = null) => { /* ... same as before, but with Geodesy role check ... */ 
    const currentUser = authService.getCurrentUser(); 
    if (!currentUser || !currentUser.token) { navigate('/login'); return; }
    if (currentUser.user.role !== 'Geodesy' && currentUser.user.role !== 'admin') { // Role check
      setError('Access Denied.'); setLoading(false); return;
    }
    setLoading(true); setError('');
    try {
      const res = await axios.get(`${API_BASE_URL}/records`, { headers: { Authorization: `Bearer ${currentUser.token}` } });
      if (res.data.status === "success") {
        const newData = Array.isArray(res.data.data) ? res.data.data : [];
        setTableData(newData);
        if (editedRowIdToCheck !== null) {
            const updatedRow = newData.find(r => r.id === editedRowIdToCheck);
            console.log(`DEBUG (fetchData Geodesy): Fetched data for edited row ID ${editedRowIdToCheck}:`, updatedRow);
        }
      } else { setError(res.data.message || "Failed to fetch data."); setTableData([]); }
    } catch (err) {
      console.error("Fetch error (Geodesy):", err);
      if (err.response) {
        const errMsg = err.response.data.message || 'Error fetching data.';
        setError(`Server Error ${err.response.status}: ${errMsg}`);
        if (err.response.status === 401 || err.response.status === 403) { authService.logout(); navigate('/login');}
      } else if (err.request) { setError('No server response.');
      } else { setError('Error setting up request.');}
      setTableData([]);
    } finally { setLoading(false); }
  }, [navigate]);

  useEffect(() => { /* ... same as before, but with Geodesy role check ... */ 
    const currentUserOnMount = authService.getCurrentUser();
    if (!currentUserOnMount || !currentUserOnMount.token) { navigate('/login'); return; }
    if (currentUserOnMount.user.role !== 'Geodesy' && currentUserOnMount.user.role !== 'admin') { // Role check
        setError('Access Denied.'); setLoading(false); return;
    }
    fetchData();
  }, [fetchData, navigate]);

  // handleAddChange and handleAddSubmit are REMOVED

  const handleEditClick = (rowData) => { /* ... same as before ... */ 
    const currentUser = authService.getCurrentUser();
    if (!currentUser || (currentUser.user.role !== 'Geodesy' && currentUser.user.role !== 'admin')) { // Role check
        alert("No permission to edit."); setError("No permission to edit."); return;
    }
    const initialEditData = {};
    allFields.forEach(field => { 
        initialEditData[field.name] = rowData[field.name] === null || rowData[field.name] === undefined ? '' : rowData[field.name];
        if (field.name.includes("date") && initialEditData[field.name]) {
            const date = new Date(initialEditData[field.name]);
            if (!isNaN(date.getTime())) { initialEditData[field.name] = date.toISOString().split('T')[0]; }
        }
    });
    setEditFormData(initialEditData); setEditingRowId(rowData.id); setShowEditModal(true); setError('');
  };
  const handleEditChange = (e) => { /* ... same as before ... */ 
    setEditFormData({ ...editFormData, [e.target.name]: e.target.value });
  };
  
  const handleEditSubmit = async () => { /* ... same as before, but uses geodesyRoleEditableFieldsOnFrontend ... */ 
    const currentUser = authService.getCurrentUser();
    if (!currentUser || !currentUser.token) { alert("Auth error."); navigate('/login'); return; }
    if (!editingRowId) { alert("No record selected."); return; }
    let dataToSubmit = {};
    const fieldsToConsider = (currentUser.user.role === 'Geodesy') ? geodesyRoleEditableFieldsOnFrontend : (currentUser.user.role === 'admin' ? Object.keys(editFormData) : []);
    fieldsToConsider.forEach(fieldName => {
        if (editFormData.hasOwnProperty(fieldName)) {
            dataToSubmit[fieldName] = (fieldName.includes('_date') && editFormData[fieldName] === '') ? null : editFormData[fieldName];
        }
    });
    if ((currentUser.user.role === 'Geodesy' || currentUser.user.role === 'admin') && Object.keys(dataToSubmit).length === 0) {
        alert("No editable fields changed or permission issue."); return;
    }
    if (currentUser.user.role !== 'Geodesy' && currentUser.user.role !== 'admin') {
        alert("You do not have permission to save changes."); return;
    }
    setLoading(true); setError('');
    try {
      const response = await axios.put(`${API_BASE_URL}/records/${editingRowId}`, dataToSubmit, { headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` }});
      if (response.data.status === "success") {
        alert("✅ Record updated!");
        const currentEditingId = editingRowId; 
        setShowEditModal(false); setEditingRowId(null); setEditFormData({});
        fetchData(currentEditingId); 
      } else { const errMsg = response.data.message || "Update error."; alert(`❌ Update failed: ${errMsg}`); setError(errMsg); }
    } catch (err) {
      let updateErrorMsg = 'Server error.';
      if (err.response) { updateErrorMsg = err.response.data.message || `Server Error ${err.response.status}.`; if (err.response.status === 401 || err.response.status === 403) { authService.logout(); navigate('/login');}}
      else if (err.request) { updateErrorMsg = 'No server response for update.'; }
      else { updateErrorMsg = 'Error setting up update request.';}
      alert(`⚠️ ${updateErrorMsg}`); setError(updateErrorMsg);
    } finally { setLoading(false); }
  };

  const getEditableFieldsForModal = useCallback(() => { /* ... same as before ... */ 
    const currentUser = authService.getCurrentUser();
    let fieldsToDisplay = [];
    if (!currentUser) return [];
    if (currentUser.user.role === 'admin') {
      fieldsToDisplay = allFields.map(field => {
        if (field.name === 'status') { return { ...field, type: 'select', options: statusOptionsForGeodesy }; }
        if (field.name === 'party_unit') { return { ...field, type: 'select', options: partyUnitOptions }; }
        if (field.name === 'season') { return { ...field, type: 'select', options: seasonOptions }; }
        if (field.name === 'working_status') { return { ...field, type: 'select', options: workingStatusOptions }; }
        return { ...field }; 
      });
    } else if (currentUser.user.role === 'Geodesy') {
      columnStructure.forEach(group => {
        group.fields.forEach(subField => {
          if (geodesyRoleEditableFieldsOnFrontend.includes(subField.name)) {
            let displayLabel = group.label;
            let fieldType = subField.name.includes("date") ? "date" : "text";
            let optionsArray;
            if (subField.name === 'status') { fieldType = 'select'; optionsArray = statusOptionsForGeodesy; displayLabel = "Status"; }
            else if (group.label === geodesyCheckingMainLabel) { displayLabel = `${geodesyCheckingMainLabel} - ${subField.label}`; }
            fieldsToDisplay.push({ name: subField.name, label: displayLabel, type: fieldType, options: optionsArray });
          }
        });
      });
    }
    return fieldsToDisplay;
  }, [columnStructure, allFields]);

  const filteredTableData = useMemo(() => { /* ... same as before ... */ 
    let data = tableData;
    if (selectedPartyUnitFilter) { data = data.filter(row => row.party_unit === selectedPartyUnitFilter); }
    if (selectedSeasonFilter) { data = data.filter(row => row.season === selectedSeasonFilter); }
    if (!searchTerm.trim()) { return data; }
    const lowercasedSearchTerm = searchTerm.toLowerCase();
    return data.filter(row => {
      return allFields.some(field => {
        const value = row[field.name];
        return value !== null && value !== undefined && String(value).toLowerCase().includes(lowercasedSearchTerm);
      });
    });
  }, [tableData, searchTerm, selectedPartyUnitFilter, selectedSeasonFilter, allFields]);

  const statusSummary = useMemo(() => { /* ... same as before ... */ 
    let dataToSummarize = tableData;
    if (selectedPartyUnitFilter) { dataToSummarize = dataToSummarize.filter(row => row.party_unit === selectedPartyUnitFilter); }
    if (selectedSeasonFilter) { dataToSummarize = dataToSummarize.filter(row => row.season === selectedSeasonFilter); }
    const counts = { allSheets: dataToSummarize.length, '1st_proof': 0, '2nd_proof': 0, '3rd_proof': 0, 'Geodesy': 0, 'Boundary_section': 0, 'GIS': 0, 'Digital_Carto': 0, 'Director_office': 0, 'DPCO': 0, 'CTP': 0, 'LPO': 0, };
    const relevantStatuses = [ "1st_proof", "2nd_proof", "3rd_proof", "Geodesy", "Boundary_section", "GIS", "Digital_Carto", "Director_office", "DPCO", "CTP", "LPO" ];
    dataToSummarize.forEach(row => { if (row.status && relevantStatuses.includes(row.status)) { counts[row.status]++; } });
    return counts;
  }, [tableData, selectedPartyUnitFilter, selectedSeasonFilter]);

  const isActionsColumnVisible = useMemo(() => { /* ... same as before, checks Geodesy role ... */ 
    const currentUser = authService.getCurrentUser();
    return currentUser && (currentUser.user.role === 'Geodesy' || currentUser.user.role === 'admin');
  }, []);

  const getRowClassByWorkingStatus = (workingStatus) => { /* ... same as before ... */ 
    if (!workingStatus) return '';
    const status = String(workingStatus).trim().toLowerCase();
    switch (status) {
      case 'in progress': return 'row-in-progress';
      case 'pending': return 'row-pending';
      case 'submitted': return 'row-submitted';
      case 'completed': return 'row-completed';
      default: return '';
    }
  };

  if (loading && tableData.length === 0 && !error) { /* ... same as before ... */ 
    return ( <div className="container mt-5 text-center"> <div className="spinner-border text-primary" role="status"> <span className="sr-only">Loading...</span></div><p>Loading...</p></div>);
  }
  if (error) { /* ... same as before ... */ 
    return (<div className="container mt-5"><div className="alert alert-danger text-center"><h4>Error</h4><p>{error}</p><Link to="/home" className="btn btn-info mt-2">Home</Link></div></div>);
  }

  return (
    <div className="container-fluid mt-4 dashboard2-party-container"> {/* Consider renaming class to dashboard-geodesy-container */}
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
        <h2 className="dashboard2-party-header mb-0 mr-3">Geodesy Dashboard - Sheet Tracker</h2>
        {/* "Add Data" Button is REMOVED */}
      </div>
      {/* Filters and Summary sections remain the same */}
      <Row className="mb-3 align-items-end">
        <Col md={4} lg={3}><Form.Group controlId="partyUnitFilter"><Form.Label className="mb-1"><small>Filter by Party/Unit:</small></Form.Label><Form.Select size="sm" value={selectedPartyUnitFilter} onChange={(e) => setSelectedPartyUnitFilter(e.target.value)} ><option value="">All Party/Units</option>{partyUnitOptions.map(option => (<option key={option} value={option}>{option}</option>))}</Form.Select></Form.Group></Col>
        <Col md={4} lg={3}><Form.Group controlId="seasonFilter"><Form.Label className="mb-1"><small>Filter by Season:</small></Form.Label><Form.Select size="sm" value={selectedSeasonFilter} onChange={(e) => setSelectedSeasonFilter(e.target.value)} ><option value="">All Seasons</option>{seasonOptions.map(option => (<option key={option} value={option}>{option}</option>))}</Form.Select></Form.Group></Col>
        <Col md={4} lg={4}><Form.Group controlId="searchTerm"><Form.Label className="mb-1"><small>Search Table:</small></Form.Label><InputGroup size="sm"><Form.Control type="text" placeholder="Search all columns..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} /><InputGroup.Text><SearchIcon /></InputGroup.Text></InputGroup></Form.Group></Col>
      </Row>
      <div className="mb-3 p-3 border rounded bg-light shadow-sm">
        <h6>Status Summary for: <strong className="text-primary">{selectedPartyUnitFilter || 'All Party/Units'}{selectedSeasonFilter && ` (Season: ${selectedSeasonFilter})`}</strong></h6>
        <Row xs={1} sm={2} md={3} lg={4} className="g-2">
            <Col><strong>Total Sheets: {statusSummary.allSheets}</strong></Col>
            {Object.entries(statusSummary).filter(([key]) => key !== 'allSheets' && statusSummary[key] > 0).map(([status, count]) => (<Col key={status}>{status.replace(/_/g, ' ')}: <span className="font-weight-bold">{count}</span></Col>))}
        </Row>
        {Object.values(statusSummary).filter((val, index) => index > 0 && val > 0).length === 0 && statusSummary.allSheets > 0 && (<Row><Col><small className="text-muted mt-1 d-block">(No items in specific statuses)</small></Col></Row>)}
        {statusSummary.allSheets === 0 && (<Row><Col><small className="text-muted mt-1 d-block">(No sheets for this selection)</small></Col></Row>)}
      </div>

      {/* Edit Data Modal */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="xl" scrollable>
        <Modal.Header><Modal.Title>Edit Geodesy Record (ID: {editingRowId})</Modal.Title></Modal.Header>
        <Modal.Body>
          <Form>
            {getEditableFieldsForModal().map(field => (
              <Form.Group key={`edit-${field.name}`} className="mb-2 row">
                <Form.Label column sm={4} className="text-sm-right">{field.label}:</Form.Label>
                <div className="col-sm-8">
                  {field.type === 'select' ? (
                    <Form.Select name={field.name} value={editFormData[field.name] || ""} onChange={handleEditChange}>
                      <option value="">-- Select {field.label} --</option>
                      {field.options.map(optionValue => (<option key={optionValue} value={optionValue}>{optionValue}</option>))}
                    </Form.Select>
                  ) : ( <Form.Control type={field.type || (field.name.includes("date") ? "date" : "text")} name={field.name} value={editFormData[field.name] || ""} onChange={handleEditChange}/> )}
                </div>
              </Form.Group>
            ))}
            <Button className="mt-3 w-100" variant="success" onClick={handleEditSubmit} disabled={loading}>{loading && showEditModal ? 'Saving...' : 'Save Changes'}</Button>
            <Button variant="secondary" className="mt-2 w-100" onClick={() => setShowEditModal(false)}>Cancel</Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Table for displaying data */}
      <div className="table-responsive">
        <table className="table table-bordered table-sm table-hover">
          <thead>
            {/* --- MODIFIED Header Rendering --- */}
            <tr>
              {columnStructure.map((group, index) => {
                if (group.fields.length === 1) { // Single field main column
                  return (
                    <th
                      key={`main-${index}`}
                      rowSpan={2} // Span both header rows
                      className={`text-center align-middle main-column-header column-group-${index} ${index === columnStructure.length -1 && !isActionsColumnVisible ? '' : 'border-right-group'}`}
                    >
                      {group.label}
                    </th>
                  );
                } else { // Multi-field main column
                  return (
                    <th
                      key={`main-${index}`}
                      colSpan={group.fields.length}
                      className={`text-center align-middle main-column-header column-group-${index} border-right-group`}
                    >
                      {group.label}
                    </th>
                  );
                }
              })}
              {isActionsColumnVisible && (
                <th rowSpan={2} className="text-center align-middle main-column-header">Actions</th>
              )}
            </tr>
            <tr>
              {columnStructure.flatMap((group, groupIndex) => {
                if (group.fields.length > 1) { // Only render sub-headers for multi-field groups
                  return group.fields.map((field, fieldIndex) => {
                    const isLastSubFieldInGroup = fieldIndex === group.fields.length - 1;
                    const headerClasses = `${getCategoryClass(group.category)} sub-column-header ${isLastSubFieldInGroup ? 'border-right-group-header' : ''}`.trim();
                    return (
                      <th key={`sub-${groupIndex}-${fieldIndex}`} className={headerClasses}>
                        {field.label}
                      </th>
                    );
                  });
                }
                return null; // No sub-headers for single-field groups that have rowSpan={2}
              })}
              {/* No sub-header needed for Actions column if it has rowSpan={2} */}
            </tr>
          </thead>
          <tbody>
            {filteredTableData.length > 0 ? (
              filteredTableData.map((row, rowIndex) => {
                const rowClass = getRowClassByWorkingStatus(row.working_status);
                return (
                <tr key={row.id || rowIndex} className={rowClass}>
                  {allFields.map((field) => {
                      const groupForField = columnStructure.find(g => g.fields.some(f => f.name === field.name));
                      const isLastFieldInMainGroup = groupForField && groupForField.fields[groupForField.fields.length - 1].name === field.name;
                      const categoryClass = groupForField ? getCategoryClass(groupForField.category) : '';
                      const cellClasses = `${categoryClass} ${isLastFieldInMainGroup || (groupForField && groupForField.fields.length === 1) ? 'border-right-group' : ''}`.trim();
                      let cellValue = row[field.name];
                      if (field.name.includes("date") && cellValue) {
                        const date = new Date(cellValue);
                        if (!isNaN(date.getTime())) {
                            const [year, month, day] = cellValue.split('T')[0].split('-');
                            if (year && month && day && year.length === 4) { cellValue = `${year}-${month}-${day}`; }
                            else { cellValue = date.toLocaleDateString('en-CA'); }
                        } else { cellValue = cellValue || "N/A"; }
                      }
                    return ( <td key={field.name} className={cellClasses}> {cellValue === null || cellValue === undefined ? '' : cellValue} </td> );
                  })}
                  {isActionsColumnVisible && (
                    <td className="text-center align-middle">
                      <Button variant="outline-primary" size="sm" onClick={() => handleEditClick(row)}>
                        Edit
                      </Button>
                    </td>
                  )}
                </tr>
              );
            })
            ) : ( 
              <tr><td colSpan={allFields.length + (isActionsColumnVisible ? 1 : 0)} className="text-center py-4">
                {searchTerm || selectedPartyUnitFilter || selectedSeasonFilter ? 'No matching records found.' : 'No data available.'}
              </td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DashboardGeodesy;
